<script>
    export let tweet_text = '';
    export let url = '';
    export let hashtags = '';
    export let via = '';
    export let related = '';

    let query = [
        tweet_text && `text=${encodeURIComponent(tweet_text)}`,
        url      ? `url=${encodeURIComponent(url)}` : `url=${window.location.href}`,
		hashtags && `hashtags=${hashtags}`,
		via      && `via=${encodeURIComponent(via)}`,
		related  && `related=${encodeURIComponent(related)}`,
    ].filter(Boolean).join('&');

    let href = `https:/www.twitter.com/intent/tweet?${query}`;
</script>

<a {href} target="_blank">
    <span class="icon-text">
        <span class="icon">
            <ion-icon name="logo-twitter"></ion-icon>
        </span>
        <span>Tweet This</span>
    </span>
</a>